module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/top_service_one-00cc2be30a8818cc62b9b01d52bbcd0f.png";